// @ts-nocheck

import { Component, Vue } from 'vue-property-decorator';
import { EComService, verifyCaptchaResult, Server, storage } from '@connectngo/sdk';
import globalVariables from "@/global";

@Component
export default class CaptchaMixin extends Vue {
	get enableCaptcha(): boolean {
		return this.$root.websiteConfig.data.fields.gcp_captcha === "1"
			&& !!this.$root.websiteConfig.data.gcp_recaptcha;
	}

	captchaReadyToPay(): boolean {
		if (this.enableCaptcha) {
			return storage.get('x-captcha-token', false) && storage.get('x-captcha-action', null) === 'PAYMENT'
		}

		return true;
	}

	loadCaptcha() {
		if (!this.enableCaptcha) {
			console.info("Cannot enable captcha due to missing 'gcp_captcha' website config, 'co-612-ecom-captcha' feature flag, or 'sitekey' env var");

			return;
		}

		document.querySelectorAll(
			'script[src="https://www.google.com/recaptcha/enterprise.js"]'
		).forEach(script => script.remove());


		window.onReCaptchaSuccess = (token) => {
			this.onReCaptchaSuccess(token);
		};

		const script = document.createElement('script');
		script.src = 'https://www.google.com/recaptcha/enterprise.js';
		script.async = true;
		script.defer = true;
		document.head.appendChild(script);
	}

	onReCaptchaSuccess(token) {
		Server.setCaptcha(token, 'PAYMENT');
		if (this.captchaReadyToPay()) {
			this.$emit('captcha-success');
		}
	}

	// Do not use this function for payment flows
	// This is only here for validating captcha in other forms if necessary
	async verifyCaptcha(token) {
		await new EComService().verifyCaptchaResult(
			token,
			'PAYMENT'
		).then(response => {
			this.isCaptchaVerified = response.httpStatus === 200
		}).catch(error => {
			this.$handleError(this, error);
		});
	}

	beforeDestroy(): void {
		window.onReCaptchaSuccess = null;
	}

	mounted(): void {
		this.loadCaptcha();
	}
}
